import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./coursesTour.css";

export function startCoursesPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giới thiệu các vùng chính của trang Khóa học: header, bộ lọc và danh sách theo môn học.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="courses-header"]',
      title: "Tiêu đề trang",
      description:
        "Hiển thị tổng số khóa học theo bộ lọc hiện tại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="courses-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description:
        "Mở nhanh tour trang, tour form, tour import và hướng dẫn HTML.",
      side: "left",
    },
    {
      selector: '[data-tour="courses-filter"]',
      title: "Bộ lọc khóa học",
      description:
        "Tìm theo tên, lọc theo môn học/phân loại/trạng thái, và thêm khóa học mới.",
      side: "bottom",
    },
    {
      selector: '[data-tour="courses-grid"]',
      title: "Danh sách khóa học",
      description:
        "Các khóa học hiển thị dạng thẻ, nhóm theo môn học. Bấm vào thẻ để mở chi tiết.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "courses-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
